import { LocalizationConfig } from "../models"
import { translateText } from "./translate"

export function getWeekDays(config: LocalizationConfig): Array<string> {
    return [
        translateText(config, 533),
        translateText(config, 527),
        translateText(config, 528),
        translateText(config, 529),
        translateText(config, 530),
        translateText(config, 531),
        translateText(config, 532),
    ]
}

export function getMonths(config: LocalizationConfig): Array<string> {
    return [
        translateText(config, 507),
        translateText(config, 508),
        translateText(config, 509),
        translateText(config, 510),
        translateText(config, 511),
        translateText(config, 512),
        translateText(config, 513),
        translateText(config, 514),
        translateText(config, 515),
        translateText(config, 516),
        translateText(config, 517),
        translateText(config, 518),
    ]
}

export function getDecimalSeparator(config: LocalizationConfig): string {
    // Format number into a decimal number using local (e.g. de-DE -> "1,1")
    const formatted = new Intl.NumberFormat(getSupportedLocal(config)).format(1.1)

    // Remove all digits and return the decimal separator itself as string
    return formatted.replace(/[0-9]/g, "").trim()
}

export function getThousandSeparator(config: LocalizationConfig): string {
    // Format number into a number (with thousand separator) using local (e.g. de-DE -> "1.000")
    const formatted = new Intl.NumberFormat(getSupportedLocal(config)).format(1000)

    // Remove all digits and return the thousand separator itself as string
    return formatted.replace(/[0-9]/g, "").trim()
}

export function getSupportedLocal(config: LocalizationConfig): string {
    try {
        try {
            // use next-language by default when no overwrite is defined
            if (!config.overwriteCurrencyFormatLocale) {
                return Intl.NumberFormat.supportedLocalesOf(config.language)[0]
            }

            // check overwriteFormatLocal when not in right format an error will be returned, when empty array there is no local for this overwriteFormatLocal
            const checkedOverwriteLocal = Intl.NumberFormat.supportedLocalesOf(config.overwriteCurrencyFormatLocale)[0]

            // if there is no valid local for overwriteFormatLocal we should use the next language itself
            return checkedOverwriteLocal ?? Intl.NumberFormat.supportedLocalesOf(config.language)[0]
        } catch (error) {
            // Fallback: return a local based on the next language on error
            console.warn(
                `${config.overwriteCurrencyFormatLocale ? "overwriteFormatLocal" : "next language"} caused an error while parsing/searching for supported Local`
            )
            return Intl.NumberFormat.supportedLocalesOf(config.language)[0]
        }
    } catch (error) {
        // Fallback: return the browser language when everything else failed (overwrite and next-language)
        console.warn("next language caused an error while parsing/searching for supported Local")
        return navigator.language
    }
}
